import { getSundayAdjustedWeekNumber } from 'utils/dateUtils/dateUtils';

const dateHelper = {
    getWeekNumber: (dateString, format) => getSundayAdjustedWeekNumber(dateString, format),
};

export { dateHelper };
